import { useQuery } from "@apollo/client";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Button from "shared/components/Button";
import Card from "shared/components/Card";
import Error from "shared/components/Error";
import Loading from "shared/components/Loading";
import { AddSquare, Export } from "shared/components/Svg/Icons/Outline";
import Swiper from "shared/components/Swiper";
import { NAME_SPACES } from "shared/locales/constants";
import graphql from "utils/api/graphql";
import { CHAIN_TYPES, SCREENS } from "utils/constants";

const Addresses = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(NAME_SPACES.PRIVATE.XO.ACCOUNT);
  const LIST = t("LIST", { returnObjects: true });
  const { data, loading, error } = useQuery(graphql.queries.ADDRESSES, {
    variables: {
      where: { token: { chain: CHAIN_TYPES.CRYPTO } },
    },
  });

  if (loading) return <Loading />;
  if (error) return <Error />;

  const {
    addresses: { data: addresses },
  } = data;

  return (
    <div className="addresses__section">
      <Swiper type="navigation">
        {addresses.map((address) => {
          const { id, token } = address;
          const balance = Number(get(token, "balances[0].value", 0));
          const isEnabled = get(token, "enabled", false);
          const status = isEnabled ? "active" : "inactive";
          return (
            <Card
              key={`account-${token.id}`}
              type="custom"
              subType="account"
              amount={balance}
              asset={{ type: token.type }}
              status={status}
              onClick={() =>
                navigate(`${SCREENS.PRIVATE.XO.ACCOUNTS.DETAIL.path}/${id}`)
              }
            />
          );
        })}
      </Swiper>
      <div className="addresses__section--actions">
        <Button
          size="small"
          mode={"gray"}
          onClick={() => {}}
          icon={<Export height={16} width={16} />}
          iconPosition="right"
        >
          {LIST.BODY.ADDRESSES.ACTIONS.SEE_ALL}
        </Button>
        <Button
          size="small"
          mode={"outline"}
          onClick={() => navigate(SCREENS.PRIVATE.XO.ACCOUNTS.OPEN.path)}
          icon={<AddSquare height={16} width={16} />}
        >
          {LIST.BODY.ADDRESSES.ACTIONS.ADD_NEW}
        </Button>
      </div>
    </div>
  );
};

export default Addresses;
